module.exports = __webpack_public_path__ + "img/icon_R2.c03578b6.png";